export interface PayCodeClass {
    AccountPayCodeId: number
    AccountId: number
    Name: string
    Code: string
    Description: string
    Multiplier: number
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn:  Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDeleted: boolean
    isSelected:number

}

export const payCodeInitialsForAdd = {
    Name: "",
    Code: "",
    Description: "",
    Multiplier: 0,
    IsDisabled: false
}

export const payCodeInitialsForUpdate = {
    AccountPayCodeId: 0,
    Name: "",
    Code: "",
    Description: "",
    Multiplier: 0,
    IsDisabled: false
}